import { Link } from "react-router-dom";
import { ArrowUpRight, FileDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export function ProductCard({ product }) {
  return (
    <article data-testid={`product-card-${product.slug}`} className="group overflow-hidden rounded-[2rem] border border-[#E6E2DA] bg-white shadow-[0_18px_60px_rgba(17,19,21,0.06)] transition-transform duration-300 hover:-translate-y-2">
      <Link to={`/products/${product.slug}`} data-testid={`product-card-link-${product.slug}`} className="block">
        <div className="relative aspect-[4/3] overflow-hidden bg-[#F4F0EA]">
          {product.image_url ? (
            <img src={product.image_url} alt={product.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          ) : (
            <div className="flex h-full items-center justify-center bg-[linear-gradient(135deg,#F4F0EA,#fff)]">
              <FileDown className="h-14 w-14 text-amber-700/60" />
            </div>
          )}
          <Badge className="absolute left-4 top-4 rounded-full bg-white/90 text-[#111315] backdrop-blur">{product.category}</Badge>
        </div>
        <div className="p-6">
          <div className="flex items-start justify-between gap-4">
            <h3 className="font-heading text-xl font-bold tracking-tight">{product.name}</h3>
            <p className="font-heading text-lg font-extrabold text-[#3F5E4D]">${product.price.toFixed(2)}</p>
          </div>
          <p className="mt-3 line-clamp-2 text-sm leading-6 text-[#525866]">{product.summary}</p>
          <div className="mt-6 flex items-center justify-between">
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8C92A0]">{product.has_file ? "Digital delivery ready" : "Delivery pending"}</span>
            <Button size="sm" variant="outline" className="rounded-full" data-testid={`product-view-button-${product.slug}`}>
              View <ArrowUpRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </Link>
    </article>
  );
}
